import { useState } from "react";
import showAlert from "../../server/ShowAlert";
import { getPresignedUrl } from "../../server/Filter";
import { UpdateProduct } from "../../server/Product";
import MyCropperComp from "./MyCrooperComp";

const MyCropper = ({ itemId, uploadImg, element }) => {
  const [src, setSrc] = useState(null);
  const [srcPrev, setSrcPrev] = useState(null);
  const [cropped, setCropped] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [preloading, setPreloading] = useState(false);

  const cancel = () => {
    setSrc(null);
    setSrcPrev(null);
    setSelectedFile(null);
    setCropped(false);
    setPreloading(false);
  };

  const save = async (e) => {
    e?.preventDefault();

    if (!cropped || !srcPrev) {
      showAlert({ msgTitle: "שגיאה", msgText: "חסר חיתוך", msgType: "error" });
      return;
    }

    setPreloading(true);

    try {
      const response = await fetch(srcPrev);
      const blob = await response.blob();
      const fileName = selectedFile?.name || `cropped_${Date.now()}.jpg`;
      const file = new File([blob], fileName, { type: blob.type });

      const { data } = await getPresignedUrl(file);
      if (!data?.uploadUrl) throw new Error("No uploadUrl");

      await fetch(data.uploadUrl, {
        method: "PUT",
        body: file,
        headers: { "Content-Type": file.type },
      });

      const img = new Image();
      img.onload = async () => {
        const media = {
          path: file.name,
          size: file.size,
          width: img.width,
          height: img.height,
          order: 0,
          default: false,
        };

        const res = await UpdateProduct({
          productId: itemId,
          media,
        });

        const addedMedia = res.data.addedImages.map((name, i) => ({
          path: name,
          order: i,
          default: i === 0,
        }));

        uploadImg({ media: addedMedia });
        cancel();
      };
      img.src = srcPrev;
    } catch (err) {
      console.error(err);
      showAlert({
        msgTitle: "שגיאה",
        msgText: "העלאת התמונה נכשלה",
        msgType: "error",
      });
      cancel();
    }
  };

  const _onChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (file.size > 20_000_000) {
      showAlert({
        msgTitle: "קובץ כבד",
        msgText: "מקסימום 20MB",
        msgType: "info",
      });
      return;
    }

    setSelectedFile(file);

    const reader = new FileReader();
    reader.onload = () => {
      setSrc(reader.result);
      setSrcPrev(null);
      setCropped(false);
    };
    reader.readAsDataURL(file);
  };

  return (
    <div className="load-image-wrapper">
      <input type="file" onChange={_onChange} />
      <MyCropperComp
        save={save}
        cancel={cancel}
        src={src}
        srcPrev={srcPrev}
        setSrcPrev={setSrcPrev}
        cropped={cropped}
        setCropped={setCropped}
        element={element}
        preloading={preloading}
      />
    </div>
  );
};

export default MyCropper;
